import React from "react";

import "./WPAcfExampleBlock.scss";

export function WPAcfExampleBlock({ block, contentMedia }) {
  const { exampleField } = block.attributes.data;
  return <div>{exampleField}</div>;
}
